import { render, staticRenderFns } from "./WitSite.vue?vue&type=template&id=237fe744&scoped=true"
import script from "./WitSite.vue?vue&type=script&lang=js"
export * from "./WitSite.vue?vue&type=script&lang=js"
import style0 from "./WitSite.vue?vue&type=style&index=0&id=237fe744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237fe744",
  null
  
)

export default component.exports